import React from "react";

import Editor from "./EditorSeeMoreLink";
import EditorWrapper from '../../EditorWrapper';


const BSeeMoreLink = props => {

    const { settings } = props;

    return (
        <div className={props.classes + ' pos-relative'} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <a href={settings.link}>{props.title ? props.title : "Zobacz więcej"}</a>
        </div>
    )
}

export default BSeeMoreLink;